import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';

// Tipagem dos dados do formulário e dos erros (opcional)
interface FormData {
  [key: string]: any; // Especifique as propriedades esperadas, se necessário
}

interface FormErrors {
  [key: string]: string; // Cada campo pode ter uma mensagem de erro
}

// Tipo do contexto
interface CreditCardContextProps {
  formData: FormData;
  setFormData: (data: FormData) => void;
  errors: FormErrors;
  setFormErrors: (errors: FormErrors) => void;
}

// Criação do contexto
const CreditCardContext = createContext<CreditCardContextProps | undefined>(
  undefined,
);

// Provider para encapsular os componentes
export const CreditCardProvider = ({ children }: { children: ReactNode }) => {
  const [formData, setFormData] = useState<FormData>({});
  const [errors, setFormErrors] = useState<FormErrors>({});

  return (
    <CreditCardContext.Provider
      value={{ formData, setFormData, errors, setFormErrors }}
    >
      {children}
    </CreditCardContext.Provider>
  );
};

// Hook customizado para usar o contexto
export const useCreditCard = () => {
  const context = useContext(CreditCardContext);
  if (!context) {
    throw new Error(
      'useCreditCardContext must be used within a CreditCardProvider',
    );
  }
  return context;
};
